import { Box } from '@mui/system'
import React, { useState } from 'react'
import { When } from 'react-if'
import YouTube from 'react-youtube'

import { getYouTubeId } from '../SubmitMap/utils'

const YouTubeWithOverlay = ({ item, height = '260px', index, activeStep }) => {
  const [isOverlay, setIsOverlay] = useState(true)

  const closeOverlay = () => {
    setIsOverlay(false)
  }

  const showOverlay = () => {
    setIsOverlay(true)
  }

  const videoProps = {
    width: '100%',
    height: '100%',
    playerVars: {
      mute: 1,
      autoplay: 1,
    },
  }

  return (
    <>
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'transparent',
          zIndex: 2,
          width: '100%',
          height,
          display: isOverlay ? 'block' : 'none',
        }}
        onClick={closeOverlay}
      />
      <When condition={activeStep === index}>
        <YouTube
          className={'youtube__player'}
          videoId={getYouTubeId(item.link)}
          opts={videoProps}
          onEnd={showOverlay}
          autoplay={1}
        />
      </When>
      <When condition={activeStep !== index}>
        <Box
          sx={{
            display: 'block',
            width: '100%',
            height,
            objectFit: 'cover',
          }}
          component={'img'}
          id={item.src}
          src={item.src}
        />
      </When>
    </>
  )
}

export default YouTubeWithOverlay
